import { 
    ref, 
    computed, 
    onMounted, 
    onUnmounted 
} from 'vue'

const windowWidth = ref(window.innerWidth)

let listenersCount = 0

const onResize = () => {
    windowWidth.value = window.innerWidth
}

export function useBreakpoints() {
    onMounted(() => {
        if (listenersCount === 0) {
            window.addEventListener('resize', onResize)
        }
        listenersCount++
        windowWidth.value = window.innerWidth
    })

    onUnmounted(() => {
        listenersCount--
        if (listenersCount === 0) {
            window.removeEventListener('resize', onResize)
        }
    })

    const isMobile = computed(() => windowWidth.value <= 480)
    const isTablet = computed(() => windowWidth.value > 480 && windowWidth.value <= 768)
    const isDesktop = computed(() => windowWidth.value > 768)

    return {
        isMobile,
        isTablet,
        isDesktop,
        windowWidth
    }
}
